import { render } from "./DatabaseModuleTab.vue?vue&type=template&id=61fabbf2&scoped=true&ts=true"
import script from "./DatabaseModuleTab.vue?vue&type=script&lang=ts"
export * from "./DatabaseModuleTab.vue?vue&type=script&lang=ts"

import "./DatabaseModuleTab.vue?vue&type=style&index=0&id=61fabbf2&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61fabbf2"]])

export default __exports__